import { useCallback, useMemo } from 'react';

import { useGetFxCurrencies } from 'api';

import { useOrganisationId } from './context';

export const useCurrencyLabel = () => {
  const organisationId = useOrganisationId<number>();

  const { data: currenciesResponse } = useGetFxCurrencies(organisationId);

  const currencies = useMemo(
    () => currenciesResponse?.data,
    [currenciesResponse]
  );

  const fromCode = useCallback(
    (code?: string) =>
      currencies?.find(
        (currency) => currency.iso_code?.toUpperCase() === code?.toUpperCase()
      )?.name,
    [currencies]
  );

  return { fromCode };
};
